import { render, staticRenderFns } from "./SimpleTabs.vue?vue&type=template&id=18d5e6c5"
import script from "./SimpleTabs.vue?vue&type=script&lang=ts"
export * from "./SimpleTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports